import React from "react";
import ImageWrapper from "../ImageWrapper";
import { Box } from "@dxp-feed/ui";
import { Text } from "@dxp-feed/ui/Text";
import { usePathname } from "next/navigation";

type promotionType = {
  productData: any;
  CardArticalId: any;
  className?: string;
  expClassName?: string;
  cardClassName?: string;
};
const PromotionsHeader = ({
  productData,
  CardArticalId,
  className = "",
  expClassName = "",
  cardClassName = "",
}: promotionType) => {
  const lastDate = productData?.[0]?.promotionEndDate;
  const pathname = usePathname();
  let expireDate: string | null = null;

  if (!lastDate || isNaN(Number(lastDate))) {
    return null;
  } else {
    const date = new Date(Number(lastDate) * 1000);

    const setDate = {
      month: "short" as const,
      day: "2-digit" as const,
    };

    expireDate = date.toLocaleDateString("en-US", setDate);
  }

  const getMatchingArticles = (
    productData: any,
    rewardTypes: any[],
    offerIdentifiers: string[],
    memberType: string
  ): number[] => {
    if (!Array.isArray(productData)) {
      return [];
    }
    const data = productData
      ?.filter(
        (item) =>
          rewardTypes.includes(item.rewardType) &&
          offerIdentifiers.includes(item.offerIdentifier) &&
          item.memberType == memberType
      )
      .map((item) => item.articleNumber);
    return data;
  };
  // **Usage**
  const matchingArticlesOne_Header1 = getMatchingArticles(
    productData,
    [1, 2, 3, 4, 5],
    ["No Min Condition", "No Min Condition with Multi Promo", "multi promo type 2"],
    "YYYYYYYYYYYYYYYY"
  );

  const matchingArticlesTwo_Header2 = getMatchingArticles(
    productData,
    [7],
    ["No Min Condition"],
    "YYYYYYYYYYYYYYYY"
  );
  const matchingArticlesTwo_Header3 = getMatchingArticles(
    productData,
    [1, 2, 3, 4, 5, 6, 7],
    ["Multi Reward"],
    "YYYYYYYYYYYYYYYY"
  );

  const matchingArticlesOne_Header7 = getMatchingArticles(
    productData,
    [1, 2, 3, 4, 5, 6, 7],
    ["No Min Condition QTY 1", "YES Min Condition QTY 1", "YES Min Condition QTY 2", "YES Min Condition QTY 3"],
    "YYYYYYYYYYYYYYYY"
  );

  const matchingArticlesOne_Header8 = getMatchingArticles(
    productData,
    [1, 2, 3, 4, 5, 6, 7],
    ["multi promo type 2"],
    "NNNNNNNNNNNNNNNN"
  );

  const matchingArticlesSeven_Header5 = getMatchingArticles(
    productData,
    [3, 5],
    ["No Min Condition"],
    "YYYYYYYYYYYYYYYY"
  );

  const matchingArticlesSeven_Header6 = getMatchingArticles(
    productData,
    [1, 2, 4, 5, 7],
    ["multi promo type 1"],
    'YYYYYYYYYYYYYYYY'
  );

  const headerStyleOne = matchingArticlesOne_Header1?.includes(CardArticalId);
  const headerStyleTwo = matchingArticlesTwo_Header2?.includes(CardArticalId);
  const headerStyleSeven = matchingArticlesOne_Header7?.includes(CardArticalId) || matchingArticlesOne_Header8?.includes(CardArticalId);  
  const headerStyleFive = matchingArticlesSeven_Header5?.includes(CardArticalId);
  const headerStyleThree = matchingArticlesTwo_Header3?.includes(CardArticalId);
  const headerStyleSix = matchingArticlesSeven_Header6?.includes(CardArticalId);
  interface MemberPrice {
    value: number | string;
  }
  const getFormattedPrice = (memberPrice: MemberPrice | any): string => {
   // if (typeof memberPrice == "number") return memberPrice.toFixed(2);
   // if (typeof memberPrice == "string") return parseFloat(memberPrice).toFixed(2);
    if (typeof memberPrice == "number")
      return memberPrice.toFixed(2);
    if (typeof memberPrice == "string")
      return parseFloat(memberPrice).toFixed(2);
    return "0.00";
  };

  return (
    <>
      {headerStyleOne && (
        <Box
          as="div"
          className={`px-2 bg-brandBlack inline-flex items-center justify-center rounded-full min-h-[32px] ${className.trim()} ${cardClassName.trim()}`}
          id="Scene_Card_exclusive_offers"
        >
          <ImageWrapper
            src="/home/scene-plus.svg"
            width={16}
            height={16}
            className="mr-2"
            alt="scene plus image"
          />
          <Text
            as="span"
            className="text-brandWhite inline-flex uppercase font-bold text-[9px]  xs:text-sm mr-2"
          >
            Member Price
          </Text>
          <Text
            as="span"
            className="text-brandWhite inline-flex font-bold text-[8px] 4xs:text-sm bg-red200 px-1 py-[2px] rounded"
          >
            ${""}
            {productData?.map((value: { memberPrice: MemberPrice | number }) =>
              getFormattedPrice(value.memberPrice)
            )}{productData[0]?.uom === "KG" ? "/kg" : ""}
          </Text>
        </Box>
      )}

      {headerStyleTwo && (
        <Box
          as="div"
          className={`px-4 gap-[2px] xs:gap-1  mb-[8px] lg:mb-[0px] bg-brandBlack inline-flex text-center items-center justify-center rounded-full min-h-[32px] py-[4px] ${className} ${cardClassName}`}
          id="Scene_Card_exclusive_offers"
        >
          <ImageWrapper
            src="/home/scene-plus.svg"
            width={16}
            height={16}
            className="mr-2"
            alt="scene plus image"
          />
          <Text
            as="span"
            className="count text-brandWhite font-bold xs:text-body text-sm"
          >
            {parseInt(productData[0].rewardValue)}
          </Text>
          <Text
            as="span"
            className="bg-purple300 xs:text-body text-sm inline-flex text-brandWhite px-[3.5px] font-bold items-center rounded-tl-[5px] max-h-[18px] rounded-br-[5px] mr-1"
          >
            PTS
          </Text>
        </Box>
      )}

      {headerStyleThree && (
        <Box
          as="div"
          className={`px-4 gap-[2px] xs:gap-1  mb-[8px] lg:mb-[0px] bg-brandBlack inline-flex text-center items-center justify-center rounded-full min-h-[32px] py-[4px] ${className} ${cardClassName}`}
          id="Scene_Card_exclusive_offers"
        >
          <ImageWrapper
            src="/home/scene-plus.svg"
            width={16}
            height={16}
            className="mr-2"
            alt="scene plus image"
          />
          <Text
            as="span"
            className="count text-brandWhite font-bold xs:text-body text-sm"
          >
            {parseInt(productData[0].memberPrice)}
          </Text>
          <Text
            as="span"
            className="bg-purple300 xs:text-body text-sm inline-flex text-brandWhite px-[3.5px] font-bold items-center rounded-tl-[5px] max-h-[18px] rounded-br-[5px] mr-1"
          >
            PTS
          </Text>
        </Box>
      )}

      {headerStyleSeven && (
        <Box
          as="div"
          className={`offerstop px-2 bg-brandBlack inline-flex items-center justify-center rounded-full min-h-[32px]  ${className} ${cardClassName}`}
          id="Scene_Card_exclusive_offers"
        >
          <ImageWrapper
            src="/home/scene-plus.svg"
            width={16}
            height={16}
            className="mr-2"
            alt="scene plus image"
          />
          <Text
            as="span"
            className="count text-brandWhite font-bold text-[9px]  xs:text-sm mr-2"
          >
            SCENE+ OFFER
          </Text>
          {/* <Text
            as="span"
            className="bg-yellow150 mr-2 text-brandBlack inline-flex xs:text-body text-sm px-[3px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
          >
            {`BUY ${productData[0].rewardTrigger} GET ${productData[0].rewardApplyTo}`}
          </Text> */}
        </Box>
      )}

      {headerStyleFive && (
        <Box
          as="div"
          className={`px-2 bg-brandBlack inline-flex items-center justify-center rounded-full min-h-[32px] ${className.trim()} ${cardClassName.trim()}`}
          id="Scene_Card_exclusive_offers"
        >
          <ImageWrapper
            src="/home/scene-plus.svg"
            width={16}
            height={16}
            className="mr-2"
            alt="scene plus image"
          />
          <Text
            as="span"
            className="text-brandWhite inline-flex uppercase font-bold text-[9px]  xs:text-sm mr-2 !leading-3"
          >
            Member Price
          </Text>
          <Text
            as="span"
            className="text-brandWhite inline-flex font-bold text-sm bg-red200 px-2 py-[2px] rounded"
          >
            ${""}
            {productData?.map((value: { memberPrice: MemberPrice | number }) =>
              getFormattedPrice(value.memberPrice)
            )}/kg
          </Text>
        </Box>
      )}

      {headerStyleSix && (
        <Box
          as="div"
          className={`px-4 gap-[2px] xs:gap-1  mb-[8px] lg:mb-[0px] bg-brandBlack inline-flex text-center items-center justify-center rounded-full min-h-[32px] py-[4px] ${className} ${cardClassName}`}
          id="Scene_Card_exclusive_offers"
        >
          <ImageWrapper
            src="/home/scene-plus.svg"
            width={16}
            height={16}
            className="mr-2"
            alt="scene plus image"
          />
          <Text
            as="span"
            className="count text-brandWhite font-bold xs:text-body text-sm"
          >
            {parseInt(productData[0].memberPrice)}
          </Text>
          <Text
            as="span"
            className="bg-purple300 xs:text-body text-sm inline-flex text-brandWhite px-[3.5px] font-bold items-center rounded-tl-[5px] max-h-[18px] rounded-br-[5px] mr-1"
          >
            PTS
          </Text>
        </Box>
      )}


      {(productData?.length > 0 || pathname?.includes("/offers")) && (
        <Box as="div" className={`inline-flex ${expClassName.trim()}`}>
          <Box as="div" className="flex items-center">
            <Text
              as="span"
             className="text-grey700 inline-flex font-bold text-sm 2xs:text-[10px] xs:text-sm 2md:text-[10px] lg:text-sm"
            >
              <Box as="span" className="font-normal mr-1">
                Offer Expires
              </Box>{" "}
              {expireDate}
            </Text>
          </Box>
        </Box>
      )}
    </>
  );
};

export default PromotionsHeader;
